import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySections } from '../components/StorySections';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FAQGuaranteeSection } from '../components/FAQGuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-bbq-dark font-sans text-gray-200 selection:bg-bbq-ember selection:text-white" data-id="element-194">
      <UrgencyBar data-id="element-195" />
      <main data-id="element-196">
        <HeroSection data-id="element-197" />
        <StorySections data-id="element-198" />
        <TestimonialsSection data-id="element-199" />
        <OfferSection data-id="element-200" />
        <PricingSection data-id="element-201" />
        <FAQGuaranteeSection data-id="element-202" />
        <ClosingSection data-id="element-203" />
      </main>
      <Footer data-id="element-204" />
      <RecentPurchaseToast data-id="element-205" />
    </div>;
}